<template>
  <v-container fluid>
    <validation-observer ref="observer" v-slot="{ invalid }">
      <v-row justify="center">
        <v-col cols="12">
          <parametros-aderencia-ais ref="aderenciaAisParams" />
        </v-col>
        <v-col cols="12">
          <v-btn
            id="btn-save-aderencia-ais"
            color="green"
            min-width="100"
            style="float: right;"
            :disabled="invalid"
            :loading="loading"
            @click="salvarAderenciaAis()"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </validation-observer>
  </v-container>
</template>

<script>

import AderenciaAisService from '@/services/AderenciaAisService';
import tourMixins from '@/mixins/tourMixins';

export default {
  name: 'AderenciaAisEdit',

  mixins: [tourMixins],
  
  components: {
    ParametrosAderenciaAis: () => import('@/components/aderenciaAis/ParametrosAderenciaAis.vue')
  },
  
  mounted() {
    this.iniciarTourPagina();
  },

  data() {
    return {
      loading: false,
      arrTour: [
        {
          element: '#titulo-aderencia-ais',
          intro: 'Aqui você poderá inserir um nome para seu relatório de aderência de AIS x Razão.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#periodo-imobilizacao-aderencia-ais',
          intro: 'Selecione o período de imobilização que será aplicado nas duas bases, AIS e Razão.',
          scrollTo: 'tooltip',
          position: 'left'
        },
        {
          element: '#btn-save-aderencia-ais',
          intro: 'Após seleção dos critérios anteriores, clique aqui para salvar e executar seu relatório de aderência.',
          scrollTo: 'tooltip',
          position: 'left'
        },
      ],
    };
  },

  methods: {
    salvarAderenciaAis() {

      this.loading = true;
      
      const data = this.$refs.aderenciaAisParams.exportData();

      AderenciaAisService.salvarAderenciaAis(data)
        .then(() => {
          this.$router.push({ name: 'Aderência AIS Histórico' });
          this.$toast.success('Aderência AIS salva com sucesso.', '', { position: 'topRight' });
        })
        .catch(err => {
          console.log('Erro: ', err);
          this.$toast.error('Erro ao salvar Aderência AIS.', '', { position: 'topRight' });
        })
        .finally(() => this.loading = false);
    },

    iniciarTourPagina() {
      if (this.tourFuncCalled) return;
      this.iniciarTour(this.arrTour);
    }
  }
};
</script>